import React from 'react'
import TrancheApproval from '../../components/ApprovedTranch/TrancheApproval'

const ApprovedTranche = () => {
  return (
    <div>
      <TrancheApproval />
    </div>
  )
}

export default ApprovedTranche